import styled from 'styled-components';

const AboutStyle = styled.div`
	--distanceTop: var(--sp33x);

	--distanceTitleDescription: var(--sp4x);
	--distanceDescriptionButton: var(--sp5x);

	--distanceInfos: var(--sp3x);
	--distanceInfoTitleDescription: var(--sp1x);

	position: relative;
	z-index: 100;

	padding-top: var(--distanceTop);
	padding-bottom: calc(var(--sectionDistance) / 2);

	.wrapper-button {
		display: flex;
		width: fit-content;
		height: fit-content;
		scale: 0;
	}

	.info-item,
	.infos-wrap {
		display: flex;
		flex-direction: column;
		gap: var(--distanceInfoTitleDescription);
	}

	.infos-wrap {
		gap: var(--distanceInfos);
	}

	.description {
		margin-top: var(--distanceTitleDescription);
		margin-bottom: var(--distanceDescriptionButton);
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTop: var(--sp16x);

		--distanceTitleDescription: var(--sp4x);
		--distanceDescriptionButton: var(--sp5x);

		--distanceInfos: var(--sp3x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTop: var(--sp16x);

		--distanceTitleDescription: var(--sp3x);
		--distanceDescriptionButton: var(--sp4x);

		--distanceInfos: var(--sp4x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceTop: var(--sp11x);

		--distanceTitleDescription: var(--sp2-5x);
		--distanceDescriptionButton: var(--sp3x);

		--distanceInfos: var(--sp3x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceTop: var(--sp15x);

		--distanceTitleDescription: var(--sp2-5x);
		--distanceDescriptionButton: var(--sp3x);

		--distanceInfos: var(--sp3x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceTop: var(--sp8x);

		--distanceTitleDescription: var(--sp2-5x);
		--distanceDescriptionButton: var(--sp3x);

		--distanceInfos: var(--sp3x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--distanceTop: var(--sp24x);

		--distanceTitleDescription: var(--sp2x);
		--distanceDescriptionButton: var(--sp2-5x);

		--distanceInfos: var(--sp3x);
		--distanceInfoTitleDescription: var(--sp1x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.wrapper-about {
			padding-top: var(--sp7x);
			margin-bottom: 0;
		}
	}
`;
export default AboutStyle;
